import { getNameIdColumn, getStatusDesColumn, renderColumn } from 'components/TableColumn/TableColumn';
import styles from './advertiserList.module.scss';
import { AdvertiserState } from 'core/advertiser/Advertiser';
import { getPartnershipModeLabel } from 'helper/PartnershipModeHelper';
import i18n from 'i18n';
import { get } from 'lodash';

export enum ADVERTISER_COLUMNS {
  NAMEID = 'id',
  STATE = 'state',
  PARTNERSHIP_MODE = 'partnershipModeId'
}

export const advertiserListColumnSettings = (isSysAdmin: boolean) => {
  const getColumnSetting = (column: ADVERTISER_COLUMNS, formatter?: any) => {
    const columnClassGetter = () => {
      return styles[column];
    };
    return renderColumn({
      sort: true,
      text: `advertiserList.headers.${column}`,
      dataField: column,
      classes: columnClassGetter,
      headerClasses: columnClassGetter
    }, formatter);
  };

  const columnSettings = [
    getNameIdColumn(
      getColumnSetting(ADVERTISER_COLUMNS.NAMEID),
      (viewModelData) => {
        if (get(viewModelData, 'state') === AdvertiserState.ARCHIVED) {
          return undefined;
        }
        return `/advertisers/${viewModelData.id}`;
      }
    ),
    getStatusDesColumn(
      getColumnSetting(
        ADVERTISER_COLUMNS.STATE
      ),
      (viewModelData) => {
        if (viewModelData.state === AdvertiserState.ARCHIVED) {
          return {
            des: i18n.t('advertiser.state.archived'),
            color: 'black'
          };
        }
        return {
          des: i18n.t('advertiser.state.active'),
          color: 'green'
        };
      }
    )
  ];

  if (isSysAdmin) {
    columnSettings.push(
      getColumnSetting(ADVERTISER_COLUMNS.PARTNERSHIP_MODE, getPartnershipModeLabel)
    );
  }

  return columnSettings;
};
